export const WORDPRESS_INTEGRATION_PATH = "/v1/integrations/wordpress";
